import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { User } from '../user/user';
import { NotificationsService } from 'angular2-notifications';
import { AuthService } from '../login/login.service';
import { DataAnamolyService } from '../catalogue/dataanamoly/dataanamoly.service';
import { DataAnalomy } from '../catalogue/dataanamoly/model/dataanamoly';
import { DPCustomerService } from '../portalv1/dp-customer.service';
import { DPUserService } from '../portalv1/dp-user.service';
import { DPSubscriptionService } from '../portalv1/dp-subscriptions.service';
import { ToasterService } from 'angular2-toaster/src/toaster.service';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { DialogRef } from 'ngx-modialog';
import { UserDetailsService } from '../shared/user.details.service';

@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html'
})
export class HomeComponent implements OnInit {

    dataAnamolies: DataAnalomy[];

    isExternal = true;
    user: User;
    result: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    date: any;
    numberOfUnexplainedData: number;
    cacheLoading = false;
    dialog: any;

    // Permissions
    private isAdmin = this.userDetailsService.isAdmin();
    private isAccountManagerAdmin = this.userDetailsService.isHelpdeskAccountManager();

    constructor(
        public auth: AuthService,
        private toasterService: ToasterService,
        private router: Router,
        private userService: UserService,
        private userDetailsService: UserDetailsService,
        private subscriptionService: DPSubscriptionService,
        private dataAnamolyService: DataAnamolyService,
        private customerService: DPCustomerService,
        private dpUserService: DPUserService,
        public modal: Modal

    ) {
        setInterval(() => {
            this.date = new Date().toUTCString();
        }, 1000);
    }

    public disabled: boolean = false;
    public status: { isopen: boolean } = { isopen: false };

    public toggled(open: boolean): void {
    }

    public toggleDropdown($event: MouseEvent): void {
        this.status.isopen = !this.status.isopen;
    }

    ngOnInit() {
        if (localStorage.getItem('is_data_api_user') === 'true') {
            this.dpUserService.getOwnUser().then(
                user => {
                    this.user = user;
                    this.isExternal = false;
                    // this.getDataAnamoly();
                    this.userService.currentUser = user;
                   // console.log(this.userService.currentUser);
                    localStorage.setItem('userName', this.user.first_name + ' ' + this.user.last_name);
                }
            );
            this.customerService
                .getCustomers()
                .then(res => {
                });
        }
        else {
            this.userService.getOwnUser()
                .then(user => {
                    this.user = user;
                    // remove below
                    this.userService.currentUser = user;
                    localStorage.setItem('userName', this.user.first_name + ' ' + this.user.last_name);

                }
                )
                .catch(error => {
                    this.errorHandler(error);
                    this.auth.logout();
                });
        }
    }

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    openKibana() {
        const newWindow = window.open('https://search-logs-cxedqw6xsg34lagtw2nitjgpwy.us-east-1.es.amazonaws.com/_plugin/kibana/app/kibana#/discover/Global-Audi-dev?_g=(refreshInterval:(display:%275%20seconds%27,pause:!t,section:1,value:5000),time:(from:now-4h,mode:quick,to:now))&_a=(columns:!(data.ipAddress,data.accountId,data.userId,data.userLogon,data.portalSection,data.dataviewType,data.eventType,data.marketIds,data.parrotIds,data.dateRange),filters:!((%27$$hashKey%27:%27object:87735%27,%27$state%27:(store:appState),meta:(alias:!n,disabled:!f,index:%27fluent-*%27,key:query,negate:!f,value:%27%7B%22bool%22:%7B%22must_not%22:%7B%22match%22:%7B%22data.userLogon%22:%22*parrotanalytics.com%22%7D%7D%7D%7D%27),query:(bool:(must_not:(match:(data.userLogon:%27*parrotanalytics.com%27))))),(%27$$hashKey%27:%27object:87736%27,%27$state%27:(store:appState),meta:(alias:!n,disabled:!f,index:%27fluent-*%27,key:data.env,negate:!f,value:prodapi),query:(match:(data.env:(query:prodapi,type:phrase))))),index:%27fluent-*%27,interval:auto,query:(query_string:(analyze_wildcard:!t,query:%27application:%20api%20AND%20level:%20INFO%20AND%20sublevel:%20AUDIT%27)),sort:!(timestamp,desc))');
        return newWindow;


    }
    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.cacheLoading = false;

        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
        if (this.notificationContent === 'Could not verify user authentication details') {
            this.isExternal = false;
        }
    }
    onClickRefreshCache(event: any) {
        event.stopPropagation();
        const dialogMessage = 'You really want to refresh Demand Portal Cache?';
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        this.processDialogActivation(this.dialog);
    }
    private processDialogActivation(dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                this. refreshPortalCache();
            }, () => {
                this.result = 'Rejected!';
            });
        });
    }

    refreshPortalCache() {
        this.cacheLoading = true;
        this.dataAnamolyService.refreshPortalCache()
            .then(res => {
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Refreshed Portal Cache';
                this.createNotification();
                this.cacheLoading = false;

            })
            .catch(error => this.errorHandler(error));
    }

    clickProfile() {
        this.router.navigate(['/parrot/parrotdetail', this.user.user_id]);
    }

    getDataAnamoly() {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        this.dataAnamolyService.getWikiAnamoly(this.dateFormatter(date), this.dateFormatter(date))
            .then(res => {
                this.dataAnamolies = res.anomalies;
                this.dataAnamolies = this.dataAnamolies.filter(c => c.state == 'unexplained');
                this.numberOfUnexplainedData = this.dataAnamolies.length;
             //   console.log(this.numberOfUnexplainedData);
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }

    dateFormatter(dateInput: Date) {
        const rawmonth = dateInput.getUTCMonth() + 1;
        const rawday = dateInput.getUTCDate();
        let month = rawmonth.toString();
        if (month.length == 1) {
            month = '0' + month;
        }
        let day = rawday.toString();
        if (day.length == 1) {
            day = '0' + day;
        }
        const year = dateInput.getUTCFullYear().toString();
        const formattedDate = year + '-' + month + '-' + day;
        return formattedDate;
    }


}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts